import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesInventarios() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      {user.menu_inventarios ? (
        <div className="container">
          <br />
          <br />

          {/* Fila 1 */}
          <Row>
            <Col md={4} align="center">
              {user.inventarios ? (
                <Button href="/ListadoInventarios" className="botonesMenu" color="success">
                  <i class="fas fa-warehouse fa-7x"></i>
                  <br />
                  <br />
                  Inventario
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-warehouse fa-7x"></i>
                  <br />
                  <br />
                  Inventario
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.inventarios ? (
                <Button href="/ListadoInventariosTotal" className="botonesMenu" color="success">
                  <i class="fas fa-boxes fa-7x"></i>
                  <br />
                  <br />
                  Inventarios Total
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-boxes fa-7x"></i>
                  <br />
                  <br />
                  Inventarios Total
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.seguimiento_inventarios ? (
                <Button href="/ListadoTracking" className="botonesMenu" color="success">
                  <i class="fas fa-search fa-7x"></i>
                  <br />
                  <br />
                  Tracking
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-search fa-7x"></i>
                  <br />
                  <br />
                  Tracking
                </Button>
              )}
            </Col>
          </Row>
          <br />

          {/* Fila 2 */}
          <Row>
            <Col md={4} align="center">
              {user.seguimiento_inventarios ? (
                <Button href="/ListadoKardex" className="botonesMenu" color="success">
                  <i class="fas fa-clipboard-list fa-7x"></i>
                  <br />
                  <br />
                  Kardex
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-clipboard-list fa-7x"></i>
                  <br />
                  <br />
                  Kardex
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.menu_traspasos_salida ? (
                <Button href="/ListadoTraspasosSalida" className="botonesMenu" color="success">
                  <i class="fas fa-sign-out-alt fa-6x"></i>
                  <br />
                  <br />
                  Traspasos
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-sign-out-alt fa-6x"></i>
                  <br />
                  <br />
                  Traspasos
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.menu_areas ? (
                <Button href="/Areas" className="botonesMenu" color="success">
                  <i class="fas fa-th-large fa-7x"></i>
                  <br />
                  <br />
                  Areas (Muestrarios)
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-th-large fa-7x"></i>
                  <br />
                  <br />
                  Areas (Muestrarios)
                </Button>
              )}
            </Col>
          </Row>
          <br />

          {/* Fila 3 */}
          <Row>
            <Col md={4} align="center">
              {user.ajustesInventario ? (
                <Button href="/ListadoAjustesInventario" className="botonesMenu" color="success">
                  <i class="fas fa-plus fa-6x"></i>
                  <br />
                  <br />
                  Ajuste Inventario
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-plus fa-6x"></i>
                  <br />
                  <br />
                  Ajuste Inventario
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.menu_disponible ? (
                <Button href="/ListadoDisponible" className="botonesMenu" color="success">
                  <i class="fas fa-tasks fa-7x"></i>
                  <br />
                  <br />
                  Disponible
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-tasks fa-7x"></i>
                  <br />
                  <br />
                  Disponible
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.disponible_vendedores ? (
                <Button href="/ListadoDisponibleVendedor" className="botonesMenu" color="success">
                  <i class="fas fa-tasks fa-7x"></i>
                  <br />
                  <br />
                  Disponible Vendedor
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-tasks fa-7x"></i>
                  <br />
                  <br />
                  Disponible Vendedor
                </Button>
              )}
            </Col>
          </Row>
          <br />

          {/* Fila 4 */}
          <Row>
            <Col md={4} align="center">
              {user.inventarios ? (
                <Button href="/ReporteUltimoPrecio" className="botonesMenu" color="success">
                  <i class="fas fa-dollar-sign fa-7x"></i>
                  <br />
                  <br />
                  Ultimo Precio Cliente
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-dollar-sign fa-7x"></i>
                  <br />
                  <br />
                  Ultimo Precio Cliente
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.inventarios ? (
                <Button href="/ReporteUltimoPrecioArticulo" className="botonesMenu" color="success">
                  <i class="fas fa-dollar-sign fa-7x"></i>
                  <br />
                  <br />
                  Ultimo Precio Articulo
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-dollar-sign fa-7x"></i>
                  <br />
                  <br />
                  Ultimo Precio Articulo
                </Button>
              )}
            </Col>
          </Row>

          {/*
            Botones desactivados (comentados, no eliminados):

            <Col md={4} align="center">
              {user.menu_traspasos_entrada ? (
                <Button href="/ListadoTraspasosEntrada" className="botonesMenu" color="success">
                  <i class="fas fa-sign-in-alt fa-6x"></i>
                  <br />
                  <br />
                  Traspasos Entrada
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-sign-in-alt fa-6x"></i>
                  <br />
                  <br />
                  Traspasos Entrada
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.menu_traspasos_entrada ? (
                <Button href="/ListadoMuestrasEntrada" className="botonesMenu" color="success">
                  <i class="fas fa-arrow-down fa-6x"></i>
                  <br />
                  <br />
                  Muestras Entrada
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-arrow-down fa-6x"></i>
                  <br />
                  <br />
                  Muestras Entrada
                </Button>
              )}
            </Col>

            <Col md={4} align="center">
              {user.menu_traspasos_salida ? (
                <Button href="/ListadoMuestrasSalida" className="botonesMenu" color="success">
                  <i class="fas fa-arrow-up fa-6x"></i>
                  <br />
                  <br />
                  Muestras Salida
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i class="fas fa-arrow-up fa-6x"></i>
                  <br />
                  <br />
                  Muestras Salida
                </Button>
              )}
            </Col>
          */}
        </div>
      ) : undefined}
    </>
  );
}

export default BotonesInventarios;
